import client from '../client';

const clinicApi = {
  /** Tenant configuration: name, branding, hours, address, booking rules. */
  getClinic: () => client.get('/clinic'),
};

export default clinicApi;
